module.exports = {
      id: "youtube-plain-usage",
      viewBox: "0 0 29 20",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#youtube-plain",
      toString: function () {
        return this.url;
      }
    }